export default __webpack_public_path__ + "static/indoor1-db8bbee7cbb08f97f23bc5e6d9476537.webp";